module.exports = __webpack_public_path__ + "img/Expo_TopicA3.e199da15.png";